import type { FaireProductEntity } from "../../entity_types/product";

export const p_usrsba94y8: FaireProductEntity = {
  token: "p_usrsba94y8",
  type: "product",
  name: "Artisanal Habanero & Mango Hot Sauce",
  brandToken: "b_bvvretxze3",
  brandName: "The Hot Sauce Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/b8d47ac5f6a1785f486d3aebf7b493eff281287922e3c1deca11d184166b8ca2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53152da6a47ae95da69e68663aa73bb7ba1486a7337a6e6f53c7597f5bbc6d39.png",
    "https://cdn.faire.com/fastly/03290b1c8d1845fa57d0fc15c947a6497846df7ee238dac5d5cb9e7826fd8ded.png",
    "https://cdn.faire.com/fastly/5eab60383ce362de6db63757018f3c6bb588432ec5447f56bc539f8aac74817a.png",
    "https://cdn.faire.com/fastly/990dbc76d5f48fdfc7b9cc0abb7d7b49ac895f53057c059ab7cd478bd82ab216.png",
    "https://cdn.faire.com/fastly/ecc9126a1ce8a4521347b5f7f7a7d46a230b98a84740813d62d031c0dfd3b32a.png",
  ],
  priceDollars: 7.55,
  description:
    "Our Habanero & Mango hot sauce is the original in our lineup. Just a hint of mango sweetness calms the heat from this full-flavoured, versatile Caribbean creation.\n\nThe beautiful colour comes from an heirloom salsa recipe, made with fresh Roma tomatoes combined with juicy mangos and red habaneros.\n\nCustomer Favorite Uses:\nChicken Wings\nPizza\nNoodles\nSpicy Sandwich Spread",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:12.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
